import { DeactivateChannelApiKey } from '@/connection/channel/api-keys';
import { serializeError } from '@/store/utils/serialize-error';
import { ChannelSettingsReducerCreator } from '../types';

const deactivateApiKeyReducer = (create: ChannelSettingsReducerCreator) => {
  return create.asyncThunk(async ({ channel, keyId }: { channel: number; keyId: string }, { rejectWithValue }) => {
    try {
      const res = await DeactivateChannelApiKey(channel, keyId);
      return res;
    } catch (error) {
      return rejectWithValue(serializeError(error));
    }
  });
};

export default deactivateApiKeyReducer;
